import { useTranslation } from "react-i18next";
import { useTheme } from "../context/ThemeContext";

export default function ThemeToggle({ config }) {
  const { t } = useTranslation("common");
  const { theme, toggleTheme } = useTheme();

  const labels = config?.sectionLabels || {};
  const isLight = theme === "light";

  const currentThemeLabel = isLight
    ? labels.themeLight || t("theme.light")
    : labels.themeDark || t("theme.dark");

  const ariaLabel = isLight
    ? labels.themeSwitchToDark || t("theme.switchToDark")
    : labels.themeSwitchToLight || t("theme.switchToLight");

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={ariaLabel}
      title={ariaLabel}
      className={[
        "group inline-flex shrink-0 items-center gap-2 rounded-full px-2 py-1.5",
        "border border-red-400/25 bg-black/60 text-white",
        "shadow-[0_0_22px_rgba(239,68,68,0.14),inset_0_1px_0_rgba(255,255,255,0.06)]",
        "backdrop-blur-xl transition duration-300",
        "hover:border-red-300/45 hover:bg-red-500/10",
        "theme-light:border-[#541717]/25 theme-light:bg-[#fff8ef]",
        "theme-light:text-[#541717]",
        "theme-light:shadow-[0_8px_24px_rgba(84,23,23,0.14)]",
        "theme-light:hover:bg-[#f7e5e2]",
      ].join(" ")}
    >
      <span
        className={[
          "hidden text-[0.65rem] font-black uppercase tracking-[0.1em] sm:inline",
          isLight
            ? "text-[#541717]"
            : "text-zinc-200 group-hover:text-red-200",
        ].join(" ")}
      >
        {currentThemeLabel}
      </span>

      <span
        className={[
          "relative h-7 w-14 overflow-hidden rounded-full border",
          "transition duration-300",
          isLight
            ? "border-[#541717]/30 bg-[#fff8ef]"
            : "border-red-400/25 bg-[#050505]",
        ].join(" ")}
      >
        <span
          className={[
            "absolute inset-0 transition duration-300",
            isLight
              ? "bg-[linear-gradient(90deg,#fff8ef,#f2d8d5)]"
              : "bg-[radial-gradient(circle_at_28%_50%,rgba(239,68,68,0.26),transparent_38%),linear-gradient(90deg,#050505,#171010)]",
          ].join(" ")}
        />

        <span
          className={[
            "absolute top-1/2 flex h-5 w-5 -translate-y-1/2",
            "items-center justify-center rounded-full",
            "text-[0.65rem] font-black shadow-md transition duration-300",
            isLight
              ? "translate-x-[29px] bg-[#541717] text-[#fff8ef]"
              : "translate-x-[4px] bg-red-300 text-[#050505]",
          ].join(" ")}
        >
          {isLight ? "☀" : "●"}
        </span>
      </span>
    </button>
  );
}